export default __webpack_public_path__ + "static/media/Menu_Icon_Action_Items.3da1b9f8.svg";